/* Autogenerated file. Do not edit manually. */

/* tslint:disable */

/* eslint-disable */
import { Provider, TransactionRequest } from "@ethersproject/providers"
import { Signer, Contract, ContractFactory, Overrides } from "ethers"

import type { EnojiDataRegistry } from "./EnojiDataRegistry"

export class EnojiDataRegistry__factory extends ContractFactory {
    constructor(signer?: Signer) {
        super(_abi, _bytecode, signer)
    }

    deploy(
        _enoji: string,
        overrides?: Overrides & { from?: string | Promise<string> }
    ): Promise<EnojiDataRegistry> {
        return super.deploy(
            _enoji,
            overrides || {}
        ) as Promise<EnojiDataRegistry>
    }
    getDeployTransaction(
        _enoji: string,
        overrides?: Overrides & { from?: string | Promise<string> }
    ): TransactionRequest {
        return super.getDeployTransaction(_enoji, overrides || {})
    }
    attach(address: string): EnojiDataRegistry {
        return super.attach(address) as EnojiDataRegistry
    }
    connect(signer: Signer): EnojiDataRegistry__factory {
        return super.connect(signer) as EnojiDataRegistry__factory
    }
    static connect(
        address: string,
        signerOrProvider: Signer | Provider
    ): EnojiDataRegistry {
        return new Contract(
            address,
            _abi,
            signerOrProvider
        ) as EnojiDataRegistry
    }
}

const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_enoji",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "constructor"
    },
    {
        inputs: [],
        name: "enoji",
        outputs: [
            {
                internalType: "contract IERC721",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_tokenId",
                type: "uint256"
            }
        ],
        name: "getData",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_tokenId",
                type: "uint256"
            },
            {
                internalType: "string",
                name: "data",
                type: "string"
            }
        ],
        name: "setData",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    }
]

const _bytecode =
    "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"
